import type {CssSize} from 'shared/ui-widgets/types';

export type PortaroSpacing = 'xs' | 's' | 'base' | 'sm' | 'm' | 'ml' | 'l' | 'xl' | 'xxl';
export type Spacing = PortaroSpacing | CssSize;
export type HtmlTag = keyof HTMLElementTagNameMap;

const portaroSpacings: PortaroSpacing[] = [
    'xs', 's', 'base', 'sm', 'm', 'ml', 'l', 'xl', 'xxl'
];

export function getSpacingCssValue(spacing: Spacing): string {
    if (portaroSpacings.includes(spacing as PortaroSpacing)) {
        return `var(--portaro-spacing-${spacing})`;
    }

    return spacing;
}

// Flex prop types
type Global = 'initial' | 'inherit' | 'unset' | 'revert' | 'revert-layer';

export type FlexDirection = 'row' | 'row-reverse' | 'column' | 'column-reverse';
export type FlexWrap = 'nowrap' | 'wrap' | 'wrap-reverse' | Global;
export type JustifyContent = | 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'space-evenly' | Global;
export type AlignItems = | 'stretch' | 'flex-start' | 'flex-end' | 'center' | 'baseline' | Global;
export type FlexGrow = number | Global;
export type FlexShrink = number | Global;
export type FlexBasis = CssSize | Global;

// Spacer and divider
export type SpacerDirection = 'vertical' | 'horizontal';
export type DividerTheme = 'default' | 'light' | 'bold' | 'muted';